<template>
  <div class="base">
    <div class="top-head">
      <inside-header title="教员详情" color="white" />
      <div class="main-one">
        <div class="header-top">
          <img src="@/assets/test-header.png" class="header-img" alt="">
          <a-button v-if="!is_focus_bool && user_is_login" type="primary" :loading="state.test"
            @click="onAttention(id)">
            <span>+关注</span>
          </a-button>
          <a-button v-if="is_focus_bool && user_is_login" type="primary" :loading="state.test"
            @click="onHaveAttention(id)">
            <span>已关注</span>
          </a-button>
        </div>
        <div class="teacher-base-info">
          <div class="base-info" style="clear: both">
            <span class="name">{{ teacher_info.nick_name }}</span>
            <span class="personal-signature">
              {{ teacher_info.personal_sign }}
            </span>
          </div>
          <div class="description">
            {{ teacher_info.self_evaluation }}
          </div>
          <div class="tag-area">
            <van-tag type="warning" round>
              {{ teacher_info.current_status }}
            </van-tag>
            <van-tag type="warning" round>
              {{ teacher_info.school }}
            </van-tag>
            <van-tag type="warning" round>
              {{ teacher_info.highest_edu }}
            </van-tag>
          </div>
        </div>
        <!-- 其他服务包 -->
        <div class="other-pack">
          <div class="orange-color-block" />
          <div class="top-area clear">
            <span class="label-left pull-left">
              其他服务包（{{ pack_list.length }}）
            </span>
          </div>
          <a-empty v-if="pack_list.length == 0 && !loading" />
          <div v-else class="list">
            <div v-for="(pack, index) in pack_list" :key="index" class="item">
              <div class="title" @click="goServicePack(pack.id)">
                {{ pack.title }}
              </div>
              <div class="description">
                {{ pack.desc }}
              </div>
              <div class="course">
                <!-- teaching_subjects -->
                <span class="course-item">语文、</span>
                <span class="course-item">数学、</span>
                <span class="course-item">英语、</span>
                <span class="course-item">物理、</span>
                <span class="course-item">化学、</span>
                <span class="course-item">自然 、</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 证书/教师资格证 -->
        <div class="certificate-area">
          <div class="title-label">
            我的证书
          </div>
          <div class="list">
            <div v-for="(certificate, index) in certificate_list_info" :key="index" class="item">
              <img :src="certificate.url" alt="" class="certificate">
              <div style="text-align: center;">
                {{ certificate.original_info.name }}
              </div>
            </div>
          </div>
        </div>
        <!-- 视频简介 -->
        <div style="padding: 0px 15px;">
          <div class="title-label" style="">
            视频介绍
          </div>
        </div>
        <div class="introduce-video-one">
          <div v-if="!showTeacherVideo" @click="onShowTeacherVideoHandle">
            <span>教师风采</span>
            <span>教师风采</span>
            <div class="play-button" />
            <div class="play-button-area" />
            <a-icon class="paly-icon" type="caret-right" />
            <video src="" width="346px" height="203px" />
          </div>
          <div v-if="showTeacherVideo" class="introduce-video-show">
            <video controls="controls">
              <source :src="teacherVideoUrl" type="video/mp4">
              <object :data="teacherVideoUrl" width="346px" height="203px">
                <embed :src="teacherVideoUrl" width="346px" height="203px">
              </object>
            </video>
          </div>
        </div>
        <!-- padding: 15 -->
        <div style="padding: 0px 15px;">
          <div style="padding: 5px 0px;">
            <div class="title-label" style="">
              授课区域
            </div>
          </div>
          <!-- 地图 -->
          <div class="map">
            <custom-map v-if="!loading" map-height="200px" :map-edit="mapEdit" :city="city" :address="address"
              :polygon="map_polygon" :circle="map_circle" @overwriteData="mapDataHandle" />
          </div>
          <div class="map-desc">
            {{ teacher_info.teaching_area }}
          </div>
          <!-- 评价  -->
          <div class="evaluation-area">
            <div class="title">
              评价（{{ tutoring_record.length }}）
            </div>
            <a-empty v-if="tutoring_record.length == 0 && !loading" />
            <div v-else class="list">
              <div v-for="(record, i) in tutoring_record" :key="i" class="item">
                <a-row>
                  <a-col class="info" :span="5">
                    <div class="img">
                      <img src="@/assets/test-header.png" alt="">
                    </div>
                    <div class="name">
                      {{ record.nick_name }}
                    </div>
                  </a-col>
                  <a-col class="content" :span="19">
                    <div class="score">
                      <a-rate :default-value="record.star > 0 ? record.star : 4" disabled
                        style="color: #ff5c00;font-size: 10px;" />
                    </div>
                    <div class="comment">
                      {{ record.commit }}
                    </div>
                  </a-col>
                </a-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <main-footer />
  </div>
  <!-- 教员介绍 -->
</template>
<script>
import { InsideHeader, MainFooter, CustomMap } from '@/components'

export default {
  name: 'RevealInfo',
  components: {
    InsideHeader,
    MainFooter,
    CustomMap
  },
  props: {
    id: {}
  },
  data() {
    return {
      loading: true,
      state: {
        selectStudents: false,
        selectTeach: false,
        showDuration: false,
        submit: false,
        test: false
      },

      student_id: '',
      teach: '',
      min_service_cycle_range: 1,
      max_service_cycle_range: 10,
      cycle: 2,
      selectDay: '',
      durationValue: 0,
      durationMin: 2,
      durationMax: 6,
      teachingData: {
        saturday: 0,
        sunday: 0,
        monday: 0,
        tuesday: 0,
        wednesday: 0,
        thursday: 0,
        friday: 0
      },
      notes: '',
      // 显示教员视频
      showTeacherVideo: false,
      teacherVideoUrl: '',
      // 地图
      mapEdit: false,
      city: '广安市',
      address: '',
      map_circle: [],
      map_polygon: [],
      // 获取到的值
      pack_list: [],
      teacher_info: {},
      tutoring_record: [],
      certificate_list_info: [],
      // qita
      teaching_subjects_str: '',
      user_is_login: false,
      is_focus_bool: false
    }
  },
  watch: {
    teacher_info(val) {
      // 教学科目
      this.teaching_subjects_str = val.teaching_subjects_str
      // 获得证书
      this.certificate_list_info = val.certificate_list_info
      this.map_circle = val.teaching_area_map_info.circle
      this.map_polygon = val.teaching_area_map_info.polygon
      this.teacherVideoUrl = val.teaching_video_info.url
      if (val.province) {
        var str = '北京市,天津市,上海市,重庆市'
        if (str.search(val.province) > -1) {
          this.city = val.province
        } else {
          this.city = val.city
        }
        this.address = val.area + val.address
      }
    }
  },
  created() {
    console.log(this.id)
    if (this.id === undefined) {
      this.$router.go(-1)
    }
    this.loadData(this.id)
  },
  methods: {
    loadData() {
      this.$http({
        url: '/index/teacher/homepage',
        methods: 'get',
        params: {
          teacher_id: this.id
        }
      }).then(res => {
        if (res.status === 'success') {
          this.loading = false
          console.log('data ....')
          console.log(res)
          const data = res.data
          this.pack_list = data.pack_list
          this.teacher_info = data.teacher_info
          this.is_focus_bool = data.is_focus_bool
          this.user_is_login = data.user_is_login
          this.tutoring_record = data.tutoring_record
          console.log(this.tutoring_record)
        }
      })
    },
    onShowTeacherVideoHandle() {
      this.showTeacherVideo = true
    },
    // 地图数据，存储到数据库中。前台使用
    mapDataHandle(e) {
    },
    onAttention(id) {
      this.state.test = true
      this.$http({
        url: 'index/user/focusTeacher',
        method: 'post',
        data: {
          teacher_id: id
        }
      }).then(res => {
        this.state.test = false
        if (res.status === 'success') {
          this.is_focus_bool = true
        } else {
          this.$toast.fail(res.message)
        }
      })
    },
    onHaveAttention(id) {
      this.state.test = true
      this.$http({
        url: 'index/user/focusTeacherCancel',
        method: 'post',
        data: {
          teacher_id: id
        }
      }).then(res => {
        this.state.test = false
        if (res.status === 'success') {
          this.is_focus_bool = false
        } else {
          this.$toast.fail(res.message)
        }
      })
    },
    goServicePack(packId) {
      this.$router.push({ name: 'TutorInfo', params: { id: packId } })
    }
  }
}
</script>
<style lang="stylus">
  .base {
      min-width: 280px;
      max-width: 420px;
      margin: auto;
      background-color: #fff;
  }

  .main-one {
    // padding: 0 15px;
    margin-top: 25px;
    background-color: #ffffff;
    border-radius: 10px;
    margin-top: 60px;

  }

  .header-top {
    padding: 0 15px;

    img {
      weight: 90px;
      height: 90px;
      border-radius: 50%;
      border: 3px solid #fff;
      float: left;
      position: relative;
      top: -40px;
    }

    button {
      float: right;
      width: 131px;
      height: 30px;
      background-image: linear-gradient(0deg, #ff5c00 0%, #fa6f20 100%),
      linear-gradient(#ff5c00, #ff5c00);
      background-blend-mode: normal, normal;
      border-radius: 15px;
      margin-top: 15px;
    }
  }

  .teacher-base-info {
    padding: 0 15px;
    clear: both;

    .base-info {
      .name {
        font-family: PingFang-SC-Bold;
        font-size: 18px;
        line-height: 16px;
        color: #333333;
        font-weight: bold;
      }

      .personal-signature {
        font-family: PingFang-SC-Medium;
        font-size: 12px;
        line-height: 16px;
        color: #666666;

        margin-left: 5px;
      }
    }

    .description {
      font-family: PingFang-SC-Medium;
      font-size: 14px;
      line-height: 16px;
      color: #666666;
      margin-top: 10px;
    }

    .tag-area {
      margin-top: 10px;

      .van-tag {
        margin-right: 5px;
      }
    }
  }

  .top-head {
    width: 100%;
    background: url('~@/assets/order/back@2x.png') no-repeat;
    // 背景图片自适应div
    background-size: contain;
    overflow: hidden;

    .course-details {
      // height: 260px;
      background-color: #ffffff;
      border-radius: 10px;
      padding: 30px 15px;
      box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);

      .title {
        font-family: PingFang-SC-Bold;
        font-size: 16px;
        line-height: 16px;
        color: #333333;
        font-weight: bold;
      }

      .desc {
        font-family: PingFang-SC-Medium;
        font-size: 14px;
        line-height: 16px;
        color: #666666;
        margin-top: 10px;
      }

      .create-order {
        margin-top: 25px;

        .teaching-day {
          padding: 10px 16px;

          .label-title {
            line-height: 40px;
          }

          .contents {

            .prop-btn-area {
              margin: 4px;

              .prop-btn {
                padding: 2px 4px;
                background-color: #f5f5f5;
                border-radius: 10px;
                font-size: 12px;
              }
            }
          }
        }

        .btn-area {

          button {
            height: 40px;
            background-color: #ff5c00;
            border-radius: 10px;
          }
        }
      }
    }
  }

  .total {
    weight: 100%;
    text-align: right;
    margin-top: 20px;

    .prefix {
      font-family: PingFang-SC-Bold;
      font-size: 12px;
      line-height: 12px;
      color: #ff5c00;
    }

    .money {
      font-family: PingFang-SC-Bold;
      font-size: 18px;
      font-weight: normal;
      color: #ff5c00;
    }
  }

  .teaching-day-label::before {
    position: absolute;
    left: -8px;
    color: #ee0a24;
    font-size: 14px;
    content: '*';
  }

  .other-area {
    padding: 0 15px;
    background-color: #fff;
  }

  .teacher-info {
    margin-top: 40px;

    .info {
      overflow: hidden;
      height: 32px;

      .name {
        height: 16px;
        font-family: PingFang-SC-Bold;
        font-size: 16px;
        line-height: 32px;
        color: #333333;
        float: left;
      }

      .number {
        font-family: PingFang-SC-Bold;
        font-size: 16px;
        color: #ff5c00;
        float: left;
        line-height: 32px;
      }

      .score {
        float: right;
      }
    }

    .description {
      font-family: PingFang-SC-Regular;
      font-size: 14px;
      line-height: 18px;
      color: #333333;
      margin-top: 15px;
    }

  }

  // 证书
  .certificate-area {
    padding: 15px;

    .list {
      overflow: hidden;
      margin-top: 10px;
      text-align: center;

      .item {
        width: 47%;
        float: left;
        margin-right: 10px;
        margin-bottom: 10px;

        img {
          // width: 100%;
          height: 100px;
          border-radius: 10px;
        }
      }
    }
  }

  // 地图
  .map {
    margin-top: 15px;
  }

  .map-desc {
    margin-top: 10px;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #333333;
  }

  // 服务包列表
  .other-pack {
    margin-top: 20px;
    box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);
    padding: 13px 15px 15px 15px;
    overflow: hidden;

    .orange-color-block {
      width: 111px;
      height: 9px;
      background-color: #fa750d;
      border-radius: 4px;
      position: relative;
      top: -16px;
    }

    .top-area {
      height: 22px;

      .label-left {
        font-family: PingFang-SC-Medium;
        font-size: 16px;
        line-height: 16px;
        color: #333333;
      }

    }

    .list {
      margin-top: 20px;

      .item {
        background-color: #f6f6f6;
        border-radius: 10px;
        margin-bottom: 15px;
        padding: 15px;

        .title {
          font-family: PingFang-SC-Medium;
          font-size: 16px;
          line-height: 16px;
          color: #333333;
        }

        .description {
          font-family: PingFang-SC-Regular;
          font-size: 14px;
          line-height: 16px;
          color: #666666;
          margin-top: 14px;
        }

        .course {
          font-family: PingFang-SC-Medium;
          font-size: 12px;
          line-height: 16px;
          color: #333333;
          margin-top: 20px;
        }
      }
    }
  }

  // 视频简介
  .introduce-video-one {
    padding: 0px 15px;
    // text-align: center;
    margin-top: 15px;
    position relative
    cursor pointer

    span {
      height: 28px;
      font-family: BDZYJT--GB1-0;
      font-size: 30px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 25px;
      letter-spacing: 0px;
      color: #eee;
    }

    span:first-child {
      position: absolute;
      top: 90px;
      left: 30px;
    }

    span:nth-child(2) {
      position: absolute;
      top: 90px;
      left: 220px;
    }

    .play-button {
      width: 36px;
      height: 36px;
      background-color: #ffffff;
      opacity: 0.2;
      border-radius: 50%;

      position: absolute;
      top: 87px;
      left: 165px;
    }

    .play-button-area {
      width: 24px;
      height: 24px;
      background-color: #ffffff;
      opacity: 0.5;
      border-radius: 50%;

      position: absolute;
      top: 93px;
      left: 171px;
    }

    .paly-icon {
      font-size: 22px;
      color: #fff;

      position: absolute;
      top: 94px;
      left: 173px;
    }

    video {
      background-image: linear-gradient(0deg, #ff5c00 0%, #ff9000 100%),
      linear-gradient(#ff5c00, #ff5c00);
      background-blend-mode: normal, normal;
      border-radius: 10px;
    }
  }

  .introduce-video-show {
    // width: 346px;
    padding: 0px 15px;
    height: 203px;
    border-radius: 10px;
    margin-top: 15px;

    video {
      width: 100%;
      height: 100%;
      object-fit: fill;
    }
  }

  // 评论区
  .evaluation-area {
    margin-top: 30px;

    .title {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      line-height: 16px;
      color: #333333;
    }

    .list {
      margin-top: 9px;

      .item {
        padding: 10px 0px;
        border-bottom: 1px solid #f6f6f6;

        .info {
          text-align: center;
          .img {
            img {
              weight: 60px;
              height: 60px;
            }
          }

          .name {
            font-family: PingFang-SC-Medium;
            font-size: 12px;
            line-height: 16px;
            color: #333333;
          }
        }

        .content  {
          .score {
          }

          .comment {
            font-family: PingFang-SC-Regular;
            font-size: 12px;
            line-height: 16px;
            color: #666666;
            margin-top: 8px;
          }
        }
      }
    }
  }

  .title-label {
    border-left: 5px solid #ff5c00;
    border-radius: 3px;
    line-height: 20px;
    background-color: #eee;
    padding-left: 5px;
  }

</style>
